import { action, computed, observable } from 'mobx';
import { ViewController } from '@estee/elc-service';
import { LoyaltyRepository } from '~repositories/LoyaltyRepository';
import { LoadLoyaltyInfoUseCase } from '~use-cases/LoadLoyaltyInfoUseCase';
import { AnalyticalTrackingUseCase } from '~use-cases/AnalyticalTrackingUseCase';
import { eventTag } from '~utils/Analytics';

class LoyaltySubmitAReceiptController extends ViewController {
    private loyaltyRepository: LoyaltyRepository;

    @observable isViewDetailsModalOpen: boolean = false;

    constructor(loyaltyRepository: LoyaltyRepository) {
        super();
        this.loyaltyRepository = loyaltyRepository;
    }

    @action
    public toggleViewDetailsModal = (ctaLabel: string) => {
        this.isViewDetailsModalOpen = !this.isViewDetailsModalOpen;

        const modalStaus = this.isViewDetailsModalOpen ? 'Open' : 'Close';
        const LoyaltyEventTracking = new AnalyticalTrackingUseCase(
            { event_name: 'loyalty_submit_receipt', event_action: 'cta_click', event_label: `${ctaLabel} - ${modalStaus}` },
            eventTag.LOYALTY_ACTIONS_TRACKING
        );
        LoyaltyEventTracking.execute();
    };

    @action
    public loaded = async () => {
        this.isLoading = true;
        await new LoadLoyaltyInfoUseCase().execute();
        this.isLoading = false;
    };

    @action
    onLinkClick(ctaLabel: string) {
        const LoyaltyEventTracking = new AnalyticalTrackingUseCase(
            { event_name: 'loyalty_submit_receipt', event_action: 'cta_click', event_label: ctaLabel },
            eventTag.LOYALTY_ACTIONS_TRACKING
        );
        LoyaltyEventTracking.execute();
    }

    @computed
    public get data() {
        return {
            loyaltyInfo: this.loyaltyRepository?.loyaltyInfo
        };
    }
}

export default LoyaltySubmitAReceiptController;
